<template>
  <div>
    <a-list bordered :data-source="constituents" class="bg-white max-w-4xl">
      <template slot="renderItem" slot-scope="item">
        <a-list-item>
          {{ item.stringValue }}
          <a-popconfirm
            title="Are you sure you want to remove this constituent?"
            ok-text="Yes"
            cancel-text="No"
            @confirm="deleteConstituent(item)"
          >
            <a-icon
              type="delete"
              class="float-right text-red-400 cursor-pointer mt-1"
            />
          </a-popconfirm>
        </a-list-item>
      </template>
      <template slot="header">
        <div class="w-full flex">
          <div class="flex-1 font-bold">Constituents</div>
          <a-button class="flex-grow-0" @click="showAddDrawer">Add</a-button>
        </div>
      </template>
    </a-list>
    <a-drawer
      title="Add constituent"
      :width="400"
      :visible="addDrawerVisible"
      @close="onDrawerClosed"
    >
      <component
        :is="addConstituentComponent"
        :index="index"
        @constituentAdded="onConstituentAdded"
      ></component>
    </a-drawer>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import AddClassConstituentForm from './AddClassConstituentForm.vue'
import AddInstitutionConstituentForm from './AddInstitutionConstituentForm.vue'

export default {
  components: {
    AddClassConstituentForm,
    AddInstitutionConstituentForm,
  },
  props: {
    index: {
      type: String,
      required: true,
    },
  },
  apollo: {
    constituents: {
      query: gql`
        query GetConstituents($indexId: String!) {
          constituents(index: $indexId) {
            key
            stringValue
          }
        }
      `,
      variables() {
        return {
          indexId: this.index,
        }
      },
    },
  },
  data() {
    return {
      constituents: [],
      addDrawerVisible: false,
      addConstituentComponent: null,
    }
  },
  mounted() {
    this.updateAddConstitutentComponent()
  },
  methods: {
    showAddDrawer() {
      this.addDrawerVisible = true
    },
    onDrawerClosed() {
      this.addDrawerVisible = false
    },
    onConstituentAdded() {
      this.$apollo.queries.constituents.refetch()
      this.addDrawerVisible = false
    },
    updateAddConstitutentComponent() {
      switch (this.index.toLowerCase()) {
        case 'sesfilc':
        case 'sesfiusd':
          this.addConstituentComponent = AddInstitutionConstituentForm
          break
        default:
          this.addConstituentComponent = AddClassConstituentForm
      }
    },
    removeConstituentFromList(constituent) {
      const index = this.constituents.indexOf(constituent)
      if (index > -1) {
        this.constituents.splice(index, 1)
      }
    },
    async deleteConstituent(constituent) {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation($input: RemoveConstituentInput) {
              removeConstituent(input: $input) {
                constituentKey
              }
            }
          `,
          variables: {
            input: {
              index: this.index,
              constituentKey: constituent.key,
            },
          },
        })
        this.removeConstituentFromList(constituent)
      } catch (error) {
        console.log(error)
        this.$message.error('An error occured while removing the constituent')
      }
    },
  },
  watch: {
    index() {
      this.updateAddConstitutentComponent()
    },
  },
}
</script>

<style></style>
